import styled from "styled-components";

export const WrapperContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 50px;
`;